export const applicationConstants = {
  // available styles for dev reference
  SUBTITLES_SIZES: ['small', 'medium', 'large', 'as-broadcast'],
  SUBTITLES_COLORS: ['black', 'white', 'green', 'blue', 'red', 'cyan', 'yellow', 'magenta', 'as-broadcast'],
  SUBTITLES_OPACITY: ['solid', 'translucent', 'transparent', 'flashing', 'as-broadcast'],
  SUBTITLES_STYLES: ['playbill', 'newsprint', 'computer', 'modern', 'casual', 'script', 'capitals', 'as-broadcast'],
  SUBTITLES_EDGES: ['none', 'raised', 'depressed', 'uniform', 'drop-shadow', 'as-broadcast'],
  MAX_START_TIME: 20000,
  // Tizen App service ID
  TIZEN_BG_SERVICE_ID: '4EiBL5eOSN.service',
  // Tizen appId
  TIZEN_APP_ID: 'MIO8xQJ7ew.unowdtc',
  TIZEN_MSG_PORT_NAME: 'FOREGROUND_APP_PORT',
  COLLECTION_PAGESIZE: 10,
  DEFAULT_ASPECT_RATIO: '2x3',
  DEFAULT_LANG: 'es',
};
